import { Injectable } from '@angular/core';

import { IFacade } from '@core/store/facade';
import { Classroom } from '@models/classroom';
import { IClassroomContext } from '@models/classroom-context';
import { IUser } from '@models/user';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as Actions from './parent.actions';
import { ParentState } from './parent.reducer';
import {
  selectChildren,
  selectChildrenLoaded,
  selectClassroomById,
  selectClassroomContext,
  selectMessages,
  selectStudentById,
  selectStudentContext,
} from './parent.selectors';

@Injectable()
export class ParentFacade implements IFacade {
  childrenLoaded$: Observable<boolean>;
  children$: Observable<IUser[]>;
  classroomContext$: Observable<IClassroomContext>;
  studentContext$: Observable<IUser>;
  messages$: Observable<string[]>;

  constructor(private store: Store<ParentState>) {
    this.children$ = this.store.select(selectChildren);
    this.childrenLoaded$ = this.store.select(selectChildrenLoaded);
    this.classroomContext$ = this.store.select(selectClassroomContext);
    this.studentContext$ = this.store.select(selectStudentContext);
    this.messages$ = this.store.select(selectMessages);
  }

  selectWithProps(func: Function, ...props: any[]): Observable<any> {
    return this.store.select(func(...props));
  }

  /**
   * @deprecated keep dispatch calls encapsulated inside the facade.
   */
  dispatch(action: Action): void {
    this.store.dispatch(action);
  }

  setStudentContext(userId: string): void {
    this.store.dispatch(Actions.setStudent({ userId }));
  }

  loadClassroom(classroomId: string): void {
    this.store.dispatch(Actions.loadClassroom({ classroomId }));
  }

  initChildren(): void {
    this.store.dispatch(Actions.initChildren());
  }

  getStudent(userId: string): Observable<IUser> {
    return this.selectWithProps(selectStudentById, userId);
  }

  getStudentClassroom(userId: string, classroomId: string): Observable<Classroom> {
    return this.selectWithProps(selectClassroomById, userId, classroomId);
  }
}
